import React, {useState, useEffect, useRef, useCallback} from 'react';
import Digit from "./Digit";
import './App.css';

const App = () => {

  const [time, setTime] = useState(new Date());
  const requestRef = useRef(null);

  const tick = useCallback(() => {
    setTime(new Date());
    requestRef.current = requestAnimationFrame(tick);
  }, []);

  useEffect(() => {
    requestRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(requestRef.current);
  }, [tick]);

  // Helper to format numbers
  const format = (num) => String(num).padStart(2, '0');

  return (
    <div className="clock">
      <Digit value={format(time.getHours())} />
      <Digit value={format(time.getMinutes())} />
      <Digit value={format(time.getSeconds())} />
    </div>
  );
};

export default App;